(ns arthur.flow.measure.mouth
  "Stage 3, the mouth: the lip rings with the head's motion taken out, and the
  aperture that decides whether there is an interior at all.

  Head-local means the anchor's space, so `pick` is read from
  `arthur.flow.measure.anchor` rather than written a second time. A ring measured
  in a different space from the fit that placed it is not a failure anyone would
  see — it is a mouth that is quietly the wrong width.

  The rings keep every slot of their table. A vertex budget is a stage-5 knob, and
  subsampling is a per-slot pick while stage 4's contour average is a per-slot
  average over time, so the two commute: smooth-then-subsample and
  subsample-then-smooth are the same numbers. That is what lets the vertex knob
  sit downstream of the smoothing knob instead of alongside it, and mouth-test
  asserts it rather than leaving it to look obvious.

  Turning the aperture into `[:vis]` on `:mouth-in` is stage 5. This reports the
  measurement, not the decision."
  (:require [arthur.domain.geom :as geom]
            [arthur.domain.landmarks :as lm]
            [arthur.flow.measure.anchor :as anchor]))

(defn measure
  "Dense landmarks plus the anchor's transforms -> head-local lip rings.

  `transforms` is whatever the caller has: the raw fit, or — normally — stage 4's
  conditioned one. Which it is belongs to the caller, because \"smooth the
  transform, never the contour\" only means anything while the two are separate."
  [{:keys [aspect]} {:keys [dense transforms]}]
  (let [local (fn [table]
                (mapv (fn [tf frame] (geom/apply-sim-all tf (anchor/pick frame table aspect)))
                      transforms dense))]
    {:outer (local lm/LIPS-OUTER)
     :inner (local lm/LIPS-INNER)
     ;; Not a separate measurement: APERTURE is slots 5 and 15 of LIPS_INNER, so
     ;; this is the inner ring's own height read off as a scalar. Writing those
     ;; two landmarks a second time is what gave the synthetic mouth a bowtie.
     :aperture (mapv (fn [[a b]] (js/Math.hypot (- (:x a) (:x b)) (- (:y a) (:y b))))
                     (local lm/APERTURE))}))
